import { render, staticRenderFns } from "./DistrictStyle.vue?vue&type=template&id=04c9da92"
import script from "./DistrictStyle.vue?vue&type=script&lang=js"
export * from "./DistrictStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports